import { cn } from "@/lib/utils";

type StatCardProps = {
  label: string;
  value: string;
  unit?: string;
  hint?: string;
  tone?: "default" | "warning" | "danger";
  className?: string;
};

const TONES = {
  default: "bg-card border-border",
  warning: "bg-warning-soft border-warning/30",
  danger: "bg-destructive-soft border-destructive/30",
} as const;

const VALUE_TONES = {
  default: "text-foreground",
  warning: "text-warning-foreground",
  danger: "text-destructive",
} as const;

const SUPPORT_TONES = {
  default: "text-muted-foreground",
  warning: "text-warning-foreground",
  danger: "text-destructive",
} as const;

export function StatCard({ label, value, unit, hint, tone = "default", className }: StatCardProps) {
  return (
    <div className={cn("rounded-xl border p-4", TONES[tone], className)}>
      <p className={cn("text-sm font-medium", SUPPORT_TONES[tone])}>{label}</p>
      {/* A long amount next to a three-letter currency has to wrap, not overflow. */}
      <p className="mt-1 flex flex-wrap items-baseline gap-1.5">
        <span className={cn("min-w-0 break-words text-2xl font-semibold tabular-nums", VALUE_TONES[tone])}>
          {value}
        </span>
        {unit ? <span className={cn("text-sm font-medium", SUPPORT_TONES[tone])}>{unit}</span> : null}
      </p>
      {hint ? <p className={cn("mt-1 text-xs", SUPPORT_TONES[tone])}>{hint}</p> : null}
    </div>
  );
}
